const scholarsAnonymousText= 'https://drive.google.com/file/d/1DaSz1Wgsw6BkS0MDxzNG8_SHlD3IH8Zo/view?usp=sharing';

export default scholarsAnonymousText;